
import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import {AgGridReact} from 'ag-grid-react';
import PropTypes from 'prop-types';
import * as firebase from 'firebase';
// import Plot from 'react-plotly.js';

import 'ag-grid/dist/ag-grid.js';
import 'ag-grid/dist/ag-grid.min.js';
import 'ag-grid/dist/styles/ag-grid.css';
import 'ag-grid/dist/styles/theme-fresh.css';

//import './user.scss';

class StudentStats extends Component {
    constructor(props) {
        super(props);
        this.db = props.dbs[props.location.state.dbi].database().ref(props.institution);
        // this.props.user.uid will give you the id of the current user
        console.log("dealermode",props.location.state.dealerMode);
        this.state = {
            students: [],
            value: "",
            user: this.props.user,
            vwap: '-',
            displayStats: {},
            studentsData: [],
            lastPrice: '-',
            bid: 1,
            ask: 41,
            isSessionAdmin: true,
            gridOptions: {
                defaultColDef: {
                    editable: false
                },
                api: {},
                columnApi: {},
                columnDefs: [
                    {
                        headerName: "#",
                        field: "id",
                        width: 75,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "User",
                        field: "user",
                        width: 175,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "Shares",
                        field: "shares",
                        width: 125,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                      headerName: "Average Position",
                      field: "avgPos",
                      width: 175,
                      filter: "agTextColumnFilter",
                      floatingFilterComponentParams: {suppressFilterButton: true},
                      suppressMenu: true
                    },
                    {
                        headerName: (props.location.state.dealerMode ? "Market Share" : "Mission"),
                        field: "mission",
                        width: 125,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "Shares Traded",
                        field: "sharesTraded",
                        width: 150,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "Percentage Limit Orders",   //"Limit:Market Order Ratio",
                        field: "lmratio",
                        width: 210,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                  /*
                   *    I kind of prefer having both, but Bruce wants this gone.      -Nate Bendich, sept 21, 2022
                    {
                        headerName: "Percentage Market Orders",   //"Limit:Market Order Ratio",
                        field: "lmratio",
                        width: 210,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                  */
                    {
                        headerName: "Max Position",
                        field: "maxsharesabsval",
                        width: 140,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "P/L",
                        field: "pl",
                        width: 125,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "BuyVWAP",
                        field: "avgbuy",
                        width: 125,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "SellVWAP",
                        field: "avgsell",
                        width: 125,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "MarketVWAP",
                        field: "marketvwap",
                        width: 150,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    }
                ],
                pagination: true,
                floatingFilter: true,
                rowData: '',
                enableSorting: true,
                onGridReady: this.onGridReady.bind(this),
                enableFilter: true
            }
        }

        this.listeners = [];
        setTimeout( ()=>{
          this.getPendingStudentsData();
        }, 600);
    }


    convertToCSV(objArray) {
      var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
      var str = '';

      for (var i = 0; i < array.length; i++) {
          var line = '';
          for (var index in array[i]) {
              if (line != '') line += ','

              line += array[i][index];
          }

          str += line + '\r\n';
      }

      return str;
  }

  exportCSVFile(headers, items, fileTitle) {
      if (headers) {
          items.unshift(headers);
      }

      // Convert Object to JSON
      var jsonObject = JSON.stringify(items);

      var csv = this.convertToCSV(jsonObject);

      var exportedFilenmae = fileTitle + '.csv' || 'export.csv';

      var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      if (navigator.msSaveBlob) { // IE 10+
          navigator.msSaveBlob(blob, exportedFilenmae);
      } else {
          var link = document.createElement("a");
          if (link.download !== undefined) { // feature detection
              // Browsers that support HTML5 download attribute
              var url = URL.createObjectURL(blob);
              link.setAttribute("href", url);
              link.setAttribute("download", exportedFilenmae);
              link.style.visibility = 'hidden';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
          }
      }
  }





playerCSVDownload(){
    console.log('DOWNLOADING PLAYER CSV');

    if(!this.props.location.state.dealerMode){
      var headers = {
        price: 'Price'.replace(/,/g, ''), // remove commas to avoid errors
        time: "Time",
        type: "Type",
        volume: "Volume",
        user: "User"
      };

      var itemsNotFormatted = [];

      this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(this.props.user.uid).child("Transactions").once("value", ss=>{
        console.log('here 1.5')
        let tradeObj = ss.val();

        if(tradeObj === undefined || tradeObj === null){
          alert('No transactions were made!');
        }

        else {
          let tradeids = Object.keys(tradeObj);
          // let displayNameRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(this.props.user.uid).child("DisplayName");
          let displayName = this.props.user.displayName;


            tradeids.map(tradeid=>{
              console.log('Here');
              let time =  tradeObj[tradeid].Time.substring(11, 20);
              let type = tradeObj[tradeid].Type;
              let volume = tradeObj[tradeid].Volume;
              let price = tradeObj[tradeid].Price;

              itemsNotFormatted.push({ price: price, time: time, type: type, volume: volume, user: displayName});
              console.log(itemsNotFormatted);
           });




          var itemsFormatted = [];
          // format the data
          itemsNotFormatted.forEach((item) => {
            itemsFormatted.push({
                price: item.price, // remove commas to avoid errors,
                time: item.time,
                type: item.type,
                volume: item.volume,
                user: item.user
              });
            });
            var fileTitle = 'trades'; // or 'my-unique-title'
            this.exportCSVFile(headers, itemsFormatted, fileTitle); // call the exportCSVFile() function to process the JSON and trigger the download
            console.log('here 2')


        }


        });
      }

      else{
          this.dealerCSVDownload(this.props.user.uid);
          return;
      }
}






  whatChanged(ref){
    let bid = false;
    let ask = false;

    let newbid = ref.order.bid;
    let newask = ref.order.ask;
    let oldbid = ref.userStats.bid;
    let oldask = ref.userStats.ask;

    if(newbid != oldbid){
      bid = true;
    }
    else{
      ask = true;
    }

    if(bid == true){
      return 'Bid';
    }
    else if(ask == true) {
      return 'Ask';
    }
  }


  detailedCSVDownload(){
    console.log('begin')

    if(!this.props.location.state.dealerMode){ //Orderbook Mode
      var headers = {
        price: 'Price'.replace(/,/g, ''), // remove commas to avoid errors
        time: "Time",
        type: "Type",
        volume: "Volume",
        user: "User"
    };

    var itemsNotFormatted = [];

    console.log('here 1')

     this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").once("value", ss=>{
       console.log('here 1.5')
       //alert(ss.val());
       let usersObj = ss.val();
       let userids = Object.keys(usersObj);

       userids.map(userid=>{
         let displayName = usersObj[userid].DisplayName;
         let tradeObj = usersObj[userid].Transactions;
         let tradeids = Object.keys(tradeObj);


       console.log("TradeObj: " + tradeObj);
       console.log("TradeIds: " + tradeids);
       console.log("TradeObj[tradeids]: " + tradeObj[tradeids]);


       tradeids.map(tradeid=>{
         console.log('Here');
         // console.log('Here 2');
         let time = tradeObj[tradeid].Time.substring(11, 20);
         let type = tradeObj[tradeid].Type;
         let volume = tradeObj[tradeid].Volume;
         let price = tradeObj[tradeid].Price;

         itemsNotFormatted.push({ price: price, time: time, type: type, volume: volume, user: displayName});
         console.log(itemsNotFormatted);
      });

    });


       var itemsFormatted = [];

    // format the data
    itemsNotFormatted.forEach((item) => {
        itemsFormatted.push({
            price: item.price, // remove commas to avoid errors,
            time: item.time,
            type: item.type,
            volume: item.volume,
            user: item.user
        });
    });

    var fileTitle = 'trades'; // or 'my-unique-title'

    this.exportCSVFile(headers, itemsFormatted, fileTitle); // call the exportCSVFile() function to process the JSON and trigger the download
      console.log('here 2')
  });




    }
    else{ //DealerMode
      var headers = {
        price: 'Price'.replace(/,/g, ''), // remove commas to avoid errors
        time: "Time",
        orderClass : "Class",
        type: "Type",
        volume: "Volume",
        bestbid: "Best Bid",
        bestask: "Best Ask",
        original: "Old Price",
        newChange: "New Price",
        user: "User"
    };

     var itemsNotFormatted = [];

    console.log('here 1')

     this.db.child("Sessions").child(this.props.location.state.sessionid).child("userLogs").once("value", ss=>{


      let usersObj = ss.val();
      let userids = Object.keys(usersObj);

       userids.map(userid=>{
         let tradeObj = usersObj[userid];
         let tradeids = Object.keys(tradeObj);





       tradeids.map(tradeid=>{
         console.log('Here');

        // temporary skip until we need bot stats too
         if(tradeObj[tradeid].order.UserId.substring(0,3) === 'bot'){
           console.log('Skipped Stats. This is a bot');
         }

         else{
          let time = tradeObj[tradeid].time.substring(11, 20);
          let orderClass = tradeObj[tradeid].order.Class;
          let type = (orderClass === 'BidAskChange') ? this.whatChanged(tradeObj[tradeid]) : tradeObj[tradeid].order.Type;
          let volume;
          let price;
          let bestbid = tradeObj[tradeid].bestBid;
          let bestask = tradeObj[tradeid].bestAsk;
          let original;
          let newChange;
          let displayName = tradeObj[tradeid].userStats.displayName;

          if(orderClass === 'BidAskChange'){
            original = (type === 'Bid') ? tradeObj[tradeid].userStats.bid : tradeObj[tradeid].userStats.ask;
            newChange = (type === 'Bid') ? tradeObj[tradeid].order.Bid : tradeObj[tradeid].order.Ask;
            volume = '0';
            price = '0';
         }

         else{
           volume = (type === 'Bid') ? tradeObj[tradeid].order.Volume : -Math.abs(tradeObj[tradeid].order.Volume);
           price = (type === 'Bid') ?  tradeObj[tradeid].userStats.bid : tradeObj[tradeid].userStats.ask ;
           original = '';
           newChange = '';

         }
         itemsNotFormatted.push({ price: price, time: time, orderClass: orderClass, type: type, volume: volume, bestbid: bestbid, bestask: bestask, original: original, newChange: newChange, user: displayName});
         console.log(itemsNotFormatted);
        }
      });
    });

    var itemsFormatted = [];

    // format the data
    itemsNotFormatted.forEach((item) => {
        itemsFormatted.push({
            price: item.price, // remove commas to avoid errors,
            time: item.time,
            orderClass: item.orderClass,
            type: item.type,
            volume: item.volume,
            bestbid: item.bestbid,
            bestask: item.bestask,
            original: item.original,
            newChange : item.newChange,
            user: item.user
        });
    });

    var fileTitle = 'trades'; // or 'my-unique-title'
    this.exportCSVFile(headers, itemsFormatted, fileTitle); // call the exportCSVFile() function to process the JSON and trigger the download
      console.log('here 2')
    });
  }
}

dealerCSVDownload(filterid=false){
  var headers = {
      //ask: 'Ask', // remove commas to avoid errors
      //bid: "Bid",
      price: "Transaction Price",
      time: "Time",
      volume: "Transaction Quantity",
      user: "UserID",
      orderType: "Order Type"
      //auction: "From Auction",
  };
  this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").once("value", ss=>{
   //alert(ss.val());
   var items = [];
   let usersObj = ss.val();
   let kys = Object.keys(usersObj);
   if (!!filterid){
     if (usersObj.hasOwnProperty(filterid)){
       kys = [filterid];
     } else {
       kys = [];
       alert("The user you are logged in as was not in this session.");
       return;
     }
   }
   kys.map(ky=>{
      let user = usersObj[ky];
      let trns = user.Transactions || {};
      Object.values(trns).forEach(trx=>{
         let result = {
            volume: trx.Volume,
            orderType: trx.Type,
            price: trx.Price,
            time: trx.Time,
            user: user.DisplayName
         }
         items.push(result);
      });
   });
   var fileTitle = 'dealermodeTransactions'; // or 'my-unique-title'
   this.exportCSVFile(headers, items, fileTitle);
  });
}


seriesCSVDownload(){
  if(!!this.props.location.state.dealerMode){ //Orderbook Mode
    //alert("Not on for dealer mode...");
    return this.dealerCSVDownload();
  }
  var headers = {
      ask: 'Ask', // remove commas to avoid errors
      bid: "Bid",
      price: "Transaction Price",
      time: "Time",
      volume: "Transaction Quantity",
      user: "UserID",
      orderType: "Order Type",
      auction: "From Auction",
  };
  this.db.child("Sessions").child(this.props.location.state.sessionid).child("TimeSeries").once("value", ss=>{
   console.log('here 1.5')
   //alert(ss.val());
   var items = [];
   let sObj = ss.val();
   this.db.child("Sessions").child(this.props.location.state.sessionid).child("UsersPending").once("value", userSS=>{
     let userLookup = userSS.val();
     userLookup["0"] = {displayName: "Bot"};
     userLookup[0] = {displayName: "Bot"};
     let kys = Object.keys(sObj);

     kys.map(ky=>{
       let pnt = sObj[ky];
       if (!pnt.hasOwnProperty("lastOrder")){
         return;
       }
       if (pnt.lastOrder == "-"){
         return;
       } //OK we have a lastOrder
       let result = {
         ask: pnt.ask,
         bid: pnt.bid,
         price: pnt.price,
         time: pnt.time,
       }
       let lOrd = JSON.parse(pnt.lastOrder);
       let oldOrder = lOrd.oldOrder;
       let newOrder = lOrd.newOrder;
       let inAnAuction = (oldOrder.hasOwnProperty("AuctionOnly") && oldOrder.AuctionOnly) || (newOrder.hasOwnProperty("AuctionOnly") && newOrder.AuctionOnly);
       result.volume = Math.min(oldOrder.Volume, newOrder.Volume);
       result.user = userLookup[newOrder.UserId].displayName;
       result.orderType = newOrder.Class;
       result.auction = inAnAuction;
       items.push(result);
       let r2 = JSON.parse(JSON.stringify(result));
       r2.user = userLookup[oldOrder.UserId].displayName;
       r2.orderType = oldOrder.Class;
       items.push(r2);
     });

    var fileTitle = 'everyTransaction'; // or 'my-unique-title'
    this.exportCSVFile(headers, items, fileTitle);
    });
  });

}

  // Graph Functions

createChartData(callback){
  let bids = [];
  let asks = [];
  let pstars = [];
  let times = [];
  var filterDates = function(tsObj){
    let theKeys = Object.keys(tsObj);
    let theDates = theKeys.map(kid=>tsObj[kid].time.substring(0,10));
    let dateSet = new Set(theDates);
    let dateArray = Array.from(dateSet);
    dateArray.sort();
    if (dateArray.length < 4){
        return {};
    }
    let findMe = dateArray[3];
    let result = {};
    theKeys.map(kid=>{
        if (tsObj[kid].time.substring(0,10) == findMe && tsObj[kid].bid > 0 && tsObj[kid].ask < 100){
            result[kid] = tsObj[kid];
        }
    });
    return result;
  }
  console.log('CREATING CHART DATA');
  if(!this.props.location.state.dealerMode){
    this.db.child("Sessions").child(this.props.location.state.sessionid).child("TimeSeries").once("value", ss=>{
      let tsObj = ss.val();
      if(tsObj === undefined || tsObj === null){
        console.log('The game has not started');
        alert('The game has not started');
      }
      else{
        tsObj = filterDates(tsObj);
        let tsids = Object.keys(tsObj);
        tsids.map(tsid=>{
          console.log('Mapping');
          let time = tsObj[tsid].time.substring(11, 19);
          let bid = (tsObj[tsid].bid);
          let ask = (tsObj[tsid].ask);
          let pstar =(tsObj[tsid].pstar || 20); // not correct

          bids.push(bid);
          asks.push(ask);
          pstars.push(pstar);
          times.push(time);
          console.log('CHART DATA CREATED');
        });

        callback(bids,asks, pstars, times);

      }

    }


    );


  }
  else{
    this.db.child("Sessions").child(this.props.location.state.sessionid).child("pstarData").once("value", ss=>{
      let tsObj = ss.val();
      if(tsObj === undefined || tsObj === null){
        console.log('The game has not started');
        alert('The game has not started');
      }
      else{
        let tsids = Object.keys(tsObj);
        tsids.map(tsid=>{
          console.log('Mapping');
          let time = tsObj[tsid].time.substring(11, 19);
          let bid = (tsObj[tsid].bid);
          let ask = (tsObj[tsid].ask);
          let pstar =(tsObj[tsid].pstar);

          bids.push(bid);
          asks.push(ask);
          pstars.push(pstar);
          times.push(time);
          console.log('CHART DATA CREATED');
        });

        callback(bids,asks, pstars, times);

      }

    });

  }


  }

  displayChart(){

    let renderChart = function (bids,asks, pstars, times){

      console.log('CREATECHARTDATA ENDS')
      console.log(bids, asks, pstars, times)

      let pstarline = {
        x: times,
        y: pstars,
        type: 'scatter',
        name: 'P*'
      };

      let testline = {
        x: [1, 2, 3, 4],
        y: [19.8, 19.8, 19.8, 19.8],
        type: 'scatter',
        name: 'Test'

      };


      let bidline = {
        x: times,
        y: bids,
        type: 'scatter',
        name: 'Bid'
      };

      let askline = {
        x: times,
        y: asks,
        type: 'scatter',
        name: 'Ask'
      };

      let data = [askline, pstarline, bidline];


      let layout = {
        title: 'P* Chart',
        xaxis: {
          title: 'Time',
          showgrid: false,
          zeroline: false
        },
        yaxis: {
          title: 'Price',
          showline: false
        }
      };

      Plotly.newPlot('chart', data, layout);

    }

    /*
    let dbtimeRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("DisplayTime");
    let dbtime = JSON.stringify(dbtimeRef);
    alert(dbtime);
    */

    if(false){
      alert('Game still in session!');
    }
    else{
     this.createChartData(renderChart);
    }
  }

  // Graph Functions End ///


    registerStats(key){
      console.log("register stats", key);

      //this is outside of the if else statment as we always want the averagePos regardless of game mode.
      let avgPosRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(key).child("Assets").child("INTC").child("Stats").child("avgPos");
      avgPosRef.on("value", ss=>{
        let data = ss.val();
        console.log("average Pos: " + data);
        if (!!data){
          let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
          console.log(displayStats);
          displayStats[key].avgPos = data;
          this.setState({displayStats});
          this.createRows();
        }
      });
      this.listeners.push(avgPosRef);

      if (!this.props.location.state.dealerMode) {
        console.log("not Dealer");
        let userStatRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(key).child("Assets").child("INTC").child("Stats");
        let mRef = userStatRef.child("Mission");
        mRef.on("value", ss=>{
          let data = ss.val();
          if (!!data){
            let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
            displayStats[key].mission = data;
            this.setState({displayStats});
            this.createRows();
          }
        });
        this.listeners.push(mRef);

        let sRef = userStatRef.child("Shares");
        sRef.on("value", ss=>{
          let data = ss.val();
          console.log("test",data);
          if (!!data){
            let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
            console.log(displayStats);
            displayStats[key].shares = data;
            this.setState({displayStats});
            this.createRows();
          }
        });
        this.listeners.push(sRef);

        let cashRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(key).child("Assets").child("Cash");
        cashRef.on("value", ss=>{
          let data = ss.val();
          if (!!data){
            let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
            displayStats[key].cash = data;
            this.setState({displayStats});
            this.createRows();
          }
        });
        this.listeners.push(cashRef);

        //  Shares Traded   - August 22, 2022
        //  Just takes whatever was in Firebase at this location and puts it in the post-game table
        let sharesTradedRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(key).child("Assets").child("INTC").child("Stats").child("sharesTraded");
        sharesTradedRef.on("value", ss=>{
          let data = ss.val();
          if (!!data) {
            let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
            displayStats[key].sharesTraded = data;
            this.setState({displayStats});
            this.createRows();
          }
        });
        this.listeners.push(sharesTradedRef);

        //   Limit : Market Order Ratio   -written by Nathan Bendich on August 22, 2022
        let lmratioRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(key).child("Assets").child("INTC").child("Stats").child("lmratio");
        lmratioRef.on("value", ss=>{
          let data = ss.val();
          if (!!data) {
            let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
            displayStats[key].lmratio = data;
            this.setState({displayStats});
            this.createRows();
          }
        });
        this.listeners.push(lmratioRef);

        //  max shares:   -written by Nathan Bendich on August 14, 2022
        let maxSharesRef = userStatRef.child("MaxShares");
        maxSharesRef.on("value", ss=>{
          let data = ss.val();
          if (!!data) {
            let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
            displayStats[key].maxsharesabsval = data;
            this.setState({displayStats});
            this.createRows();
          }
        });
        this.listeners.push(maxSharesRef);

        let bvwapRef = userStatRef.child("BuyVWAP");
        bvwapRef.on("value", ss=>{
          let data = ss.val();
          if (!!data){
            let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
            displayStats[key].bvwap = data;
            this.setState({displayStats});
            this.createRows();
          }
        });
        this.listeners.push(bvwapRef);
        let svwapRef = userStatRef.child("SellVWAP");
        svwapRef.on("value", ss=>{
          let data = ss.val();
          if (!!data){
            let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
            displayStats[key].svwap = data;
            this.setState({displayStats});
            this.createRows();
          }
        });
        this.listeners.push(svwapRef);
      } else {
        let userStatRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Dealers").child(key);
        let otherStatRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(key).child("Assets").child("INTC").child("Stats");
        let svwapRef = otherStatRef.child("SellVWAP");
        let bvwapRef = otherStatRef.child("BuyVWAP");
        let svwapVal = 0;
        let bvwapVal = 0;
        svwapRef.on("value", ss=>{
            svwapVal = ss.val() || 0;
            //displayStats[key].svwap = svwapVal;//data.avgSell;
            //this.setState
            //this.createRows
        });
        bvwapRef.on("value", ss=>{
           bvwapVal = ss.val() || 0;
           //displayStats[key].bvwap = bvwapVal;//data.avgBuy;
           //etc
        });
        setTimeout(()=>{
            userStatRef.on("value", ss=>{
              let data = ss.val();
              if (!!data){
                let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
                displayStats[key].shares = data.position;
                displayStats[key].mission = data.marketShare;
                displayStats[key].cash = data.cash;
                //displayStats[key].maxsharesabsval = data.maxsharesabsval;   //avgBuy;
                displayStats[key].bvwap = bvwapVal;//data.avgBuy;
                displayStats[key].svwap = svwapVal;//data.avgSell;
                this.setState({displayStats});
                this.createRows();
              }
            });
        }, 0);//So this is silly... a poor man's Promise.All, the dealer VWAPs are bad and this is a front-end way to fix it... micro race condition that will never happen
        this.listeners.push(userStatRef);
        this.listeners.push(svwapRef);
        this.listeners.push(bvwapRef);
      }


    }

    getPendingStudentsData() {
        // this.setState({
        //     studentsData:[]
        // })
        console.log("Users Pending Loading");
        var studentRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("UsersPending");
        //this.userRef = firebase.database().ref().child(this.props.institution).child("Sessions").child(this.props.location.state.sessionid).child("Users").child(this.props.uid).child("INTC").child("stats");
        studentRef.on('value', snap =>{
          let rawData = snap.val();
          console.log("data of student ",rawData);
          let studentInfo;
          let students = [];

          let displayStats = this.state.displayStats;
          for(var key in rawData){
            if (rawData[key].displayName){
                students.push(rawData[key]); //has .uid which == key too
                if (!displayStats.hasOwnProperty(key)){
                  console.log(key);
                  displayStats[key] = {displayName: rawData[key].displayName, mission: "-", shares: "-", avgPos: 0, maxsharesabsval: "-", sharesTraded: "-", lmratio: "-", bvwap: "-", svwap: "-", cash: "-"};
                  let that = this;
                  let uid = key;
                  setTimeout( ()=>{
                      that.registerStats(uid);
                  }, 0);
                }
            }
          }

          this.setState({
              studentsData: students,
              displayStats: displayStats
          });
          console.log("student data ", this.state.studentsData);
         // this.state.dataItemsSell = this.state.studentsDataSell.map((numbersSell) =><div>{numbersSell}</div>);
         // this.state.dataItemsBuy = this.state.studentsDataBuy.map((numbersBuy) =><li>{numbersBuy}</li>);
        })
        this.listeners.push(studentRef);
    }

    componentDidMount() {
      var vwapRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Assets").child("INTC").child("VWAP");
      var priceRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("ImportantData").child("SessionData").child("lastPrice");
      var bidRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("ImportantData").child("SessionData").child("bid");
      var askRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("ImportantData").child("SessionData").child("ask");
      if (this.props.location.state.dealerMode){
        vwapRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("DealerMarket").child("VWAP");
        priceRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("DealerMarket").child("lastPrice");
      }
      vwapRef.on("value", ss=>{
        let data = ss.val();
        if (!!data){
          this.setState({"vwap": data});
        }
      });
      this.listeners.push(vwapRef);

      priceRef.on("value", ss=>{
        let data = ss.val();
        if (!!data){
          this.setState({"lastPrice": data});
        }
      });
      this.listeners.push(priceRef);

      bidRef.on("value", ss=>{
        let data = ss.val();
        if (!!data){
          this.setState({"bid": data});
        }
      });
      this.listeners.push(bidRef);

      askRef.on("value", ss=>{
        let data = ss.val();
        if (!!data){
          this.setState({"ask": data});
        }
      });
      this.listeners.push(askRef);
    }

    to1DecPlace(value){
      if (!value){
        return "-";
      } else {
        return value.toFixed(1);
      }
    }

    formatMoney(value){
      if (!value){
        return "-";
      } else {
        return value.toFixed(4);
      }
    }

    componentWillUnmount() {
        this.listeners.map(theRef=>{
          theRef.off();
        });
    }

    filterQuick(event) {
        console.log(this.state.gridOptions.rowData);
        this.state.gridOptions.api.setQuickFilter(event.target.value);

    }

    createRows() {
        let rows = [];
        for (let i = 0; i < this.state.studentsData.length; i++) {
            let student = this.state.studentsData[i];
            let stats = this.state.displayStats[student.uid];

            rows.push({
                id: i + 1,
                user: student.displayName,
                shares: stats.shares,
                avgPos: stats.avgPos.toFixed(2),
                mission: stats.mission,
                maxsharesabsval: stats.maxsharesabsval, // "maxsharesabsval" shows how risk-tolerant the student was (Bruce's idea);   August 10, 2022
                sharesTraded: stats.sharesTraded,  // Sept 27, 2022
                lmratio: this.to1DecPlace( parseFloat ( stats.lmratio)),
              // TODO : rename "lmratio" to "percentLimit"    - Sept 21, 2022
                pl: this.formatMoney(parseFloat(stats.cash) + parseFloat(stats.shares)*((parseFloat(this.state.bid) + parseFloat(this.state.ask))/2)),
                avgbuy: stats.bvwap,
                avgsell: stats.svwap,
                marketvwap: this.formatMoney(parseFloat(this.state.vwap))
            });
        }
        this.state.gridOptions.rowData = rows;
        this.setState(this.state);
    }

    onGridReady(params) {
        this.state.gridOptions.api = params.api;
        this.state.gridOptions.columnApi = params.columnApi;
        this.state.gridOptions.api.selectAll();
        this.setState(this.state)
    }

    render() {
        let dbi = parseInt(this.props.location.state.dbi);
        let dbObj = this.props.dbs[dbi];
        console.log(dbObj);
        let findme = "-"
        if (dbObj.hasOwnProperty("options_")){
          findme=dbObj.options_.databaseURL;
        }
        if (dbObj.hasOwnProperty("apps")){
          findme = dbObj.apps[dbi].options_.databaseURL;
        }
        let targetURL = `${findme}/${this.props.institution}/Sessions/${this.props.location.state.sessionid}/TimeSeries.json`;
        return (
            <div>
                <button onClick={() => this.state.gridOptions.api.exportDataAsCsv()}>Export Summary Data</button>
                <button onClick={() => this.playerCSVDownload()}>Export Your Trades</button>
                <button onClick={() => this.seriesCSVDownload()}>Every Transaction</button>
                <button onClick={() => this.displayChart()}>Display Chart</button>

                <div id='chart'></div>
                <div className="leader-board ag-theme-material">
                    <AgGridReact
                        columnDefs={this.state.gridOptions.columnDefs}
                        rowData={this.state.gridOptions.rowData}
                        gridOptions={this.state.gridOptions}
                    />
                </div>
            </div>
        );
    }
}

export default StudentStats// counterclockwise.   (starts at bottom / bottom-left)



// WEBPACK FOOTER //
// ./src/components/Dashboard/StudentStats.js